import { PurchaseUploadDialog } from './PurchaseUploadDialog';
import type { LastUploadRecord } from './purchaseTrendPage';

export function PurchaseTrendUploadSection({
  canUpload,
  open,
  onOpenChange,
  onImported,
  initialFile = null,
}: {
  canUpload: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImported: (record: LastUploadRecord) => void;
  initialFile?: File | null;
}) {
  if (!canUpload) {
    return null;
  }
  return (
    <PurchaseUploadDialog
      open={open}
      onOpenChange={onOpenChange}
      onImported={onImported}
      initialFile={initialFile}
    />
  );
}
